module.exports = __webpack_public_path__ + "img/hr-H-B-3-load-connect-shadow.620531bc.png";